import { render } from "./RadialBarChart.vue?vue&type=template&id=505a0038&scoped=true"
import script from "./RadialBarChart.vue?vue&type=script&lang=js"
export * from "./RadialBarChart.vue?vue&type=script&lang=js"

import "./RadialBarChart.vue?vue&type=style&index=0&id=505a0038&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-505a0038"]])

export default __exports__